const getBriefParamsString = () => {
  const params = new URLSearchParams([
    ['t[]', 'brief'], ['t[]', 'dict'],
    ['t[]', 'dict:product'], ['t[]', 'product:company'],
    ['t[]', 'company'], ['t[]', 'company:pool'], ['t[]', 'pool'], ['t[]', 'dict:model'], ['t[]', 'dict:efficiencyMetric'],
    ['t[]', 'brief:metric'], ['t[]', 'dict:channel'], ['t[]', 'brief:stage'], ['t[]', 'task:short'], ['t[]', 'taskType'],
  ])

  return params.toString()
}

export default getBriefParamsString
